import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/gtm-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/vercel/path0/components/shared/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSettingsDialog"] */ "/vercel/path0/components/shared/CookieSettingsDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFrame"] */ "/vercel/path0/components/shared/SiteFrame.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastHandler"] */ "/vercel/path0/components/toast-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentProvider"] */ "/vercel/path0/contexts/cookie-consent-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-inter\",\"fallback\":[\"system-ui\",\"arial\"]}],\"variableName\":\"inter\"}");
